/** Shared React Query settings for GET /numbers/getNumbers */
export const availablePhoneNumbersQueryKey = [
  'available-phone-numbers',
] as const;

export const availablePhoneNumbersQueryConfig = {
  /** Data rarely changes; avoid refetch on every navigation back to Phone Numbers. */
  staleTime: 1000 * 60 * 5,
  /** Keep cache after leaving the page so returning does not hit the network. */
  gcTime: 1000 * 60 * 30,
} as const;
